import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TableCell, TableRow } from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import { IconButton, TextField } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';

const OfferPaymentPlanAdvanceSplitRowComponent = ({
  splitValueRow,
  onPropertyChange,
  onDelete,
  t,
  idx,
  readOnlyFull,
  downPaymentSplitWrite
}) => {
  return (
    <TableRow>
      <TableCell>
        <DateTime
          id={'offerPaymentPlanAdvanceSplitCard_' + idx + '_dueDate'}
          name={'DueDate'}
          value={splitValueRow.dueDate}
          disabled={readOnlyFull || !downPaymentSplitWrite}
          isClearable
          onChange={value => onPropertyChange('dueDate', value)}
        />
      </TableCell>
      <TableCell>
        <TextField
          id={'offerPaymentPlanAdvanceSplitCard_' + idx + '_advanceAmount'}
          name={'AdvanceAmount'}
          fullWidth
          isNumeric
          value={splitValueRow.advanceAmount || ''}
          disabled={readOnlyFull || !downPaymentSplitWrite}
          onChange={value => onPropertyChange('advanceAmount', value)}
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          id={'offerPaymentPlanAdvanceSplitCard_' + idx + '_deleteBtn'}
          color='primary'
          variant='text'
          size='small'
          tooltip={t('Delete')}
          onClick={onDelete}
          disabled={readOnlyFull || !downPaymentSplitWrite}
        >
          <Delete />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

OfferPaymentPlanAdvanceSplitRowComponent.propTypes = {
  splitValueRow: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  readOnlyFull: PropTypes.bool,
  downPaymentSplitWrite: PropTypes.bool.isRequired
};

export default compose(withTranslation()(OfferPaymentPlanAdvanceSplitRowComponent));
